module.exports = __webpack_public_path__ + "static/media/coupon.70703a34.svg";